import {
  ConnectionState,
  DropReason,
  PayloadDirection,
  PayloadSizeBucket,
} from './types';

export type StompMetricsSink = {
  onConnectionState?: (event: {
    state: ConnectionState;
    previous?: ConnectionState;
    durationMs?: number;
    generation: number;
  }) => void;
  onReconnectAttempt?: (event: { attempt: number; delayMs: number }) => void;
  onReconnectOutcome?: (event: { attempt: number; outcome: 'success' }) => void;
  onLogicalSubscriptions?: (event: { topics: number; refs: number }) => void;
  onMessageIn?: (event: { channel: string; bytes?: number }) => void;
  onMessageOut?: (event: {
    destination: string;
    category: string;
    bytes: number;
  }) => void;
  onQueueSize?: (event: { count: number; bytes: number }) => void;
  onDropped?: (event: {
    reason: DropReason;
    category: string;
    bytes?: number;
  }) => void;
  onCoalesced?: (event: { channel: string; droppedCount: number }) => void;
  onInboundFlush?: (event: { items: number; durationMs: number }) => void;
  onSlowHandler?: (event: { channel: string; durationMs: number }) => void;
  onPayloadSize?: (event: {
    direction: PayloadDirection;
    bucket: PayloadSizeBucket;
    bytes: number;
  }) => void;
  onDuplicateSubscriptionPrevented?: (event: {
    key: string;
    channel: string;
  }) => void;
  onCleanupComplete?: (event: { generation: number }) => void;
};

const NOOP_SINK: StompMetricsSink = {};

let sink: StompMetricsSink = NOOP_SINK;

export function setStompMetricsSink(next: StompMetricsSink | null | undefined) {
  sink = next || NOOP_SINK;
}

export function getStompMetricsSink(): StompMetricsSink {
  return sink;
}

/**
 * Lets per-message paths skip work that only exists to feed metrics (payload
 * measuring, handler timing) while no sink is installed, which is the default.
 */
export function hasStompMetricsSink(): boolean {
  return sink !== NOOP_SINK;
}

export function resetStompMetricsSink() {
  sink = NOOP_SINK;
}
